import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    question: '韩国漫画网上的漫画都是免费的吗？',
    answer: '是的，韩国漫画网提供的所有韩漫资源均可免费在线阅读。我们聚合了全网优质免费韩漫资源，支持下拉式阅读，无需付费即可享受完整的漫画阅读体验。目前已收录超过12,000部韩国漫画，并且每日都在持续更新。',
  },
  {
    id: 2,
    question: '支持在手机上阅读韩国漫画吗？',
    answer: '完全支持！韩国漫画网完美适配手机、平板和电脑端浏览。我们采用下拉式阅读模式，在手机上只需上下滑动即可流畅阅读，无需翻页操作。无论您使用iOS还是Android设备，都能获得出色的韩漫在线阅读体验。',
  },
  {
    id: 3,
    question: '漫画的更新频率是怎样的？',
    answer: '韩国漫画网坚持每日更新，实时同步各大热门韩漫的最新章节。热门连载作品通常在原作者更新后数小时内即可在本站阅读。您可以通过「最新动态」模块查看实时更新列表，也可以按分类浏览感兴趣的漫画。',
  },
  {
    id: 4,
    question: '韩国漫画网上的漫画都有哪些类型？',
    answer: '我们涵盖韩国漫画的全品类，包括但不限于：恋爱漫画、奇幻漫画、动作漫画、悬疑漫画、搞笑漫画、校园漫画、穿越漫画、都市漫画、古风漫画等。您可以通过首页「漫画分类」模块快速定位感兴趣的类型，也可以使用话题标签发现热门作品。',
  },
  {
    id: 5,
    question: '有没有推荐的韩漫入门作品？',
    answer: '如果您是第一次接触韩国漫画，推荐从人气榜单排名靠前的作品开始，如《心动频率》（恋爱甜宠）、《剑与魔法》（奇幻冒险）、《第七个夜晚》（悬疑推理）等。您也可以查看首页的「精选推荐」和「热门推荐」模块，我们会定期更新编辑精选的高分韩漫。',
  },
];

export default function FaqSection() {
  const [openIds, setOpenIds] = useState<number[]>([1]);

  const toggleFaq = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            关于韩国漫画网的常见疑问解答，快速了解我们的服务
          </p>
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3">
          {faqItems.map((item) => {
            const isOpen = openIds.includes(item.id);
            return (
              <div
                key={item.id}
                className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(item.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 pr-4">
                    {item.question}
                  </h3>
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                    isOpen ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-600'
                  }`}>
                    <i className="ri-add-line text-lg"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}